var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSpinnerAiDark = function SvgSpinnerAiDark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 16,
    viewBox: "0 0 16 16",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spinner-ai-dark_svg__a)",
    d: "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M2.495 8a5.505 5.505 0 1 0 11.01 0 5.505 5.505 0 0 0-11.01 0",
    opacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#spinner-ai-dark_svg__b)",
    d: "M14.753 8c.689 0 1.257-.562 1.15-1.242A8 8 0 0 0 9.243.097C8.561-.01 8 .558 8 1.247c0 .69.565 1.233 1.237 1.388a5.5 5.5 0 0 1 4.128 4.128C13.52 7.435 14.064 8 14.753 8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-ai-dark_svg__a",
    x1: -1.306,
    x2: 16.816,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E44EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "spinner-ai-dark_svg__b",
    x1: -1.306,
    x2: 16.816,
    y1: 8,
    y2: 8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E44EC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSpinnerAiDark);
export default ForwardRef;